module.exports = __webpack_public_path__ + "static/media/direct-debit_ewDqbihq.cc3a0e36.svg";